import { Book } from '@apis/index'
import { Config } from '@apis/types'
import {
  Table,
  Typography,
  Category,
  TableActions,
  Card,
  Row,
  Skeleton,
  Image,
} from '@components'
import BackNavigation from '@components/backNavigation'
import Column from '@components/column'
import ImageGallery from '@components/image/imgaeGallery'
import { StyleBg } from '@components/status/style'
import TableDate from '@components/table/date'
import { styleCard } from '@pages/admin/auth/style'
import { Actions, store } from '@store/index'
import { Constant } from '@utils/index'
import { Fragment, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'

const BookListed = () => {
  const navigate = useNavigate()
  const { id, bookId } = useParams()
  const {
    items: bookList,
    totalPages,
    loading: booksLoading,
  } = useSelector((state: any) => state.userBooks)
  const { data: book, loading } = useSelector((state: any) => state.book)

  const [params, setParams] = useState<any>({ page: 1, limit: 10, userId: id })
  const fetchBooks = async (action: Config['store']['action'], params: any) => {
    await Book.getSpecificUserBooks(action, params, 'userBooks').catch(() => {})
  }
  const findBook = async (bookId: any) => {
    await Book.getBook(bookId).catch(() => {})
  }
  useEffect(() => {
    if (!bookList?.length) {
      fetchBooks('set', params)
    }
    if (bookId && !book?.id) {
      findBook(bookId)
    }
    return () => {
      store.dispatch(Actions.reset('book'))
    }
  }, [])
  const columns = [
    {
      title: 'Book Image',
      key: 'image',
      render: (item: any) => (
        <Image
          fit="cover"
          height={160}
          width={120}
          src={
            item?.coverImage
              ? `${process.env.BUCKET_URL}/${item?.coverImage}`
              : Constant.defaultNoImage
          }
        />
      ),
    },
    {
      title: 'Book Name',
      key: 'listedName',
      render: (item: any) => (
        <Typography content={item?.name} tc="greyText" size={14} weigth={400} />
      ),
    },
    {
      title: 'Author',
      key: 'listedAuthor',
      render: (item: any) => (
        <Typography
          content={item?.author}
          tc="greyText"
          size={14}
          weigth={400}
        />
      ),
    },
    {
      title: 'Genre',
      key: 'listedGenre',
      render: (item: any) => <Category category={item?.categoryData?.name} />,
    },
    {
      title: 'Date',
      key: 'listedDate',
      render: (item: any) => (
        <TableDate date={item?.createdAt} hasTime={false} />
      ),
    },
    {
      title: 'Action',
      key: 'listedAction',
      render: (item: any) => (
        <TableActions
          type="button"
          hasDelete={false}
          hasEdit={false}
          onView={() => {
            onView(item)
          }}
        />
      ),
    },
  ]

  const onView = (item: any) => {
    store.dispatch(Actions.reset('book'))

    navigate(
      `/admin/user-managements/view/${id}/bookView/${item?.id}?tab=bookListed`,
    )
    findBook(item?.id)
  }

  return (
    <Fragment>
      {bookId ? (
        <Fragment>
          <BackNavigation />

          <Card customStyle={styleCard} radius={12}>
            {!!loading ? (
              <>
                <Row
                  justifyContent="space-between"
                  styleRow={{ width: '100%' }}
                >
                  <Column styleColumn={{ width: '25%' }}>
                    <Skeleton
                      width={100}
                      height={300}
                      radius={12}
                      style={{ width: '100%' }}
                    />
                  </Column>
                  <Column styleColumn={{ width: '70%' }} rowGap={10}>
                    <Column rowGap={10}>
                      <Skeleton width={150} radius={12} height={20} />

                      <Skeleton width={100} radius={12} height={20} />
                    </Column>
                    <StyleBg tc="primaryText" bg="cyan100">
                      <Skeleton width={100} radius={12} height={20} />
                    </StyleBg>
                    <Typography content={'Description'} size={18} />
                    <Skeleton width={300} radius={12} height={20} />
                    <Skeleton width={300} radius={12} height={20} />
                    <Skeleton width={300} radius={12} height={20} />
                  </Column>
                </Row>
              </>
            ) : (
              <Row justifyContent="space-between" styleRow={{ width: '100%' }}>
                <Column styleColumn={{ width: '25%' }}>
                  <ImageGallery
                    images={[
                      book.coverImage,
                      ...(book?.additionalImages
                        ? book?.additionalImages?.map((item) => {
                            return item?.images
                          })
                        : []),
                    ]}
                  />
                </Column>
                <Column styleColumn={{ width: '70%' }} rowGap={10}>
                  <Column>
                    <Typography content={book?.name} size={24} />
                    <Typography content={book?.author} size={20} tc="primary" />
                  </Column>
                  <StyleBg tc="primaryText" bg="cyan100">
                    {book?.categoryData?.name}
                  </StyleBg>
                  <Typography content={'Description'} size={18} />
                  <Typography
                    content={book?.description}
                    size={16}
                    tc="grey400"
                    styleText={{ textAlign: 'justify' }}
                  />
                </Column>
              </Row>
            )}
          </Card>
        </Fragment>
      ) : (
        <Table
          columns={columns}
          onClickRow={(item) => {
            onView(item)
          }}
          loading={booksLoading}
          data={bookList}
          paginationProps={{
            totalPages: totalPages,
            perPage: params.limit,
            activePage: params?.page,
            handleOnClick: (pageNo) => {
              const updateParams = { ...params, page: pageNo }
              setParams(updateParams)
              fetchBooks('set', updateParams)
            },
          }}
        />
      )}
    </Fragment>
  )
}

export default BookListed
